<template>
  <div id="admin-page">
    
    <b-container>
    <div></div>
    <b-row>
      <b-col md="3">
         <b-button block  squared variant="primary" to="/problem/add">New Problem</b-button>
      </b-col>
      <b-col>1 of 3</b-col>
    </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  created() {
    const api = "/user/me";
    const token = localStorage.getItem("access_token");
    this.$http
      .get(api, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      //.then((response) => {
      //  //console.log(response.data);
      //});
  },
  data() {
    return {};
  },
};
</script>